import { jsonPut } from 'api'

export const activateAccount = (accountKey, validationCode) =>
    jsonPut(`${THINX_ACCOUNT_URL}/subscription/account/activate/${accountKey}`, {
        'X-API-Key': THINX_BASE_API_URL_API_KEY,
        validationCode,
    }).catch(error => {
        throw new Error(error.message)
    })
